import { useMemo } from 'react';
import { useReportTemplateValue } from 'hooks/useReportTemplate';
import { normalizeSlateContent, convertFieldsToUnified } from 'domains/reporter/Reporter/Fields';
import { buildBookmarkTextMap } from './utils';
import type { TemplateBookmarkTextMap } from './utils';

export type UseTemplateBookmarkTextMapReturn = {
  templateBookmarkTextMap: TemplateBookmarkTextMap;
  isTemplateReady: boolean;
};

// Mirrors the normalizeSlateContent/convertFieldsToUnified transform applied before template
// content is inserted into the editor (Fields.Context.tsx), so the map's text matches what was
// actually inserted, including its bookmark name de-duplication pass.
export const useTemplateBookmarkTextMap = (): UseTemplateBookmarkTextMapReturn => {
  const template = useReportTemplateValue();

  const templateBookmarkTextMap = useMemo(
    () =>
      buildBookmarkTextMap(
        template == null
          ? null
          : normalizeSlateContent(template.content ?? convertFieldsToUnified(template.sections))
      ),
    [template]
  );

  return { templateBookmarkTextMap, isTemplateReady: template != null };
};
